import { create } from 'zustand';
import { ProfileDataType } from '../../Types/profile.type';
import { editProfileDataAction, getProfileDataAction } from './actions';

type ProfileType = {
  profileData: ProfileDataType;
  profileLoading: boolean;
  profileError: boolean;
  editProfileLoading: boolean;
  editProfileError: boolean;
  getProfileDataAction: (clubBranchId: number) => Promise<boolean>;
  editProfileDataAction: (body: {
    clubBranchId: number;
    name?: string;
    sex?: string;
    email?: string;
    birthday?: string;
  }) => Promise<boolean>;
};

const useProfileStore = create<ProfileType>((set) => ({
  profileData: null,
  profileLoading: false,
  profileError: false,
  editProfileLoading: false,
  editProfileError: false,
  getProfileDataAction: (clubBranchId) =>
    getProfileDataAction(set, clubBranchId),
  editProfileDataAction: (body) => editProfileDataAction(set, body)
}));

export default useProfileStore;
